export function formatName(object: any) {
  const firstName = object?.firstName || object?.first_name
  const lastName = object?.lastName || object?.last_name
  return `${firstName || ''} ${lastName || ''}`.trim()
}
